import { Component, OnInit,AfterViewInit} from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";

declare var $: any;

@Component({
	selector: 'app-validate-form',
	templateUrl: './validate-form.component.html',
	styleUrls: ['./validate-form.component.css',]
})
export class ValidateFormComponent implements OnInit,AfterViewInit {

	validateCode: string = "";
	newMethodId: number;
	constructor(private apiService: ApiService,
		private route: ActivatedRoute,
		private router: Router,
		private commonService: CommonService) {}

	ngOnInit() {
		this.route.params.subscribe(params => {
      this.newMethodId = params['methodId'];
    });
	}

	ngAfterViewInit() {
		this.commonService.initPage();
	}

	validate() {
		let validateInput = $("#CodeValidateTxt");
		if(this.validateCode != "") {
			validateInput.removeClass('showValidateTxt');
			this.submitValide();
		} else {
			validateInput.addClass('showValidateTxt');
		}
	}
	
	submitValide() {
		this.gotoLearnMap();
	}
	
	gotoLearnMap(){
		let link = ['learning-map', this.newMethodId];
		this.router.navigate(link);
	}

}


// WEBPACK FOOTER //
// ./src/app/validate-form/validate-form.component.ts